import { usePlatformUpdate } from '@reapitform/hooks'
import { IDefaultSpecialTerms } from '../../types'

export const useDefaultSpecialConditionPost = () => {
  const path: string = '/api/Organization/DefaultSpecialCondition'

  const [addSpecialCondition, isLoading, returnData, isSuccess, isError] = usePlatformUpdate<
    Omit<IDefaultSpecialTerms, 'id' | 'lastUpdatedUTC'>,
    IDefaultSpecialTerms
  >({
    path: path,
    method: 'POST',
    headers: {},
    errorMessage: 'Failed to create new template!',
    successMessage: 'Template successfully created',
  })

  return { addSpecialCondition, returnData, isLoading, isSuccess, isError }
}
